import React from 'react';

import LongText from '@/src/components/common/Elements/LongText/LongText';

type FileSizeProps = {
  value;
  itemId?;
  maxLength?: number;
};

const DEFAULT_NULL_VALUE = '--';

const FileSize = ({ value, itemId, maxLength = 25 }: FileSizeProps) => {
  const tooltipId = `filseize_${itemId}`;
  let content = value;

  if (value !== DEFAULT_NULL_VALUE) {
    content = `${value}`;
  }

  return <LongText value={content} tooltipId={tooltipId} maxLength={maxLength} />;
};

export default FileSize;
